module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-controls"
  }, [(_vm.canCreatePipeline) ? _c('a', {
    staticClass: "btn btn-create",
    attrs: {
      "href": _vm.newPipelinePath
    }
  }, [_vm._v("\n    Run Pipeline\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hasCiEnabled) ? _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": _vm.helpPagePath
    }
  }, [_vm._v("\n    Get started with Pipelines\n  ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.ciLintPath
    }
  }, [_vm._v("\n    CI Lint\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/template-compiler?{"id":"data-v-5eb08234"}!/var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/nav_controls.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5eb08234"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/nav_controls.vue
// module chunks = pipelines